window.dd = console.log;
window.php  = {};
window.php.rtrim = require('locutus/php/strings/rtrim');
window.php.sprintf = require('locutus/php/strings/sprintf');